<template>
  <div class="about">
    <h1>This is the login page</h1>
  </div>
</template>